module.exports = __webpack_public_path__ + "img/bepartner.b2694a84.png";